/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


// require('bootstrap');


import { App, plugin } from '@inertiajs/inertia-vue'
import Vue from 'vue'

Vue.use(plugin)
import { InertiaProgress } from '@inertiajs/progress'

InertiaProgress.init()

Vue.prototype.$route = (...args) => route(...args)

import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)



//
//
//


import * as Sentry from '@sentry/vue';

import { Integrations } from "@sentry/tracing";
Sentry.init({
    Vue: Vue,
    dsn: 'https://1c744b8a0ed6461ca476a179b07d20d7@o68473.ingest.sentry.io/5227208',
    integrations: [
        new Integrations.BrowserTracing({
            tracingOrigins: ["merchant.livro.ca", /^\//],
        }),
    ],
    tracingOptions: {
        trackComponents: true,
    },
    // logErrors: true,
    tracesSampleRate: 0,
});



window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import 'array-flat-polyfill';

import * as GmapVue from 'gmap-vue'
Vue.use(GmapVue, {
    load: {
        key: 'AIzaSyA3QbwU8ZAj_23VbD6R6uopBcsmMfp3Tm4',
        libraries: 'places,drawing,visualization',
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then set installComponents to 'false'.
    //// If you want to automatically install all the components this property must be set to 'true':
    installComponents: true
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/Menu.vue -> <example-component></example-component>
 */

const el = document.getElementById('app')
if (el) {
    new Vue({

        metaInfo: {
            titleTemplate: (title) => title ? `${title} - Livro` : 'Livro'
        },

        render: h => h(App, {
            props: {
                initialPage: JSON.parse(el.dataset.page),
                // resolveComponent: name => import(`./Public/${name}`).then(module => module.default),
                resolveComponent: name => require(`./Public/${name}`).default,
            },
        }),
    }).$mount(el);
}
